import { ViewStream } from "spyne";
import { ScriptContentTraits } from "traits/script-content-traits";

export class ScriptContentTabView extends ViewStream {
  constructor(props = {}) {
    props.tagName = "li";
    props.class = "script-content-tab";
    props.dataset = {};
    props.dataset["scriptNum"] = props.scriptNum;
    props.dataset["eventType"] = "script-content";
    //props.template = `<p>${props.data}</p>`;
    //console.log("PROPS DATA ",props.data);
    props.template = require("../templates/script-content-tab.tmpl.html");
    super(props);
  }

  addActionListeners() {
    // return nexted array(s)

    const arr = [];
    arr.push(
      ScriptContentTraits.scriptContent$CreateActionListeners(this.props),
    );
    return arr;
  }

  onCodeRevealEvent(e) {
    const { scriptNum } = e.payload;
    const currentScriptNum = this.props.data.scriptNum;
    const isActiveBool = parseInt(scriptNum) === parseInt(currentScriptNum);
    //console.log("CODE REVEAL EVENT ",{scriptNum,currentScriptNum,isActiveBool,e},this.props.scriptNum);
    this.props.el$("button").toggleClass("active", isActiveBool);
  }

  broadcastEvents() {
    // return nexted array(s)
    return [["button", "click"]];
  }

  onRendered() {
    this.props
      .el$("button")
      .toggleClass("active", this.props.data.scriptNum === 0);
    this.addChannel("CHANNEL_CODE_CONTAINER");
  }
}
